import { render, staticRenderFns } from "./KazaxstanPage.vue?vue&type=template&id=316a5c07"
import script from "./KazaxstanPage.vue?vue&type=script&lang=js"
export * from "./KazaxstanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports